import React from 'react'
import { FormattedMessage } from 'react-intl'

export const CAPTION = (
    <FormattedMessage
        id='vehicle_filter.caption'
        defaultMessage='Выбор техники'
    />
)

export const SELECT_VEHICLES = (count) => (
    <FormattedMessage
        id='vehicle_filter.apply'
        defaultMessage='Сохранить выбор ({count})'
        values={{ count }}
    />
)

export const TYPES = ['lightTank', 'mediumTank', 'heavyTank', 'AT-SPG', 'SPG']

export const LEVELS_ALL_CAPTION = (
    <FormattedMessage
        id='level_select.all_caption'
        defaultMessage='Все уровни'
    />
)

export const NATIONS_CAPTIONS = {
    ussr: (
        <FormattedMessage
            id='nations_select.captions.ussr'
            defaultMessage='СССР'
        />
    ),
    germany: (
        <FormattedMessage
            id='nations_select.captions.germany'
            defaultMessage='Германия'
        />
    ),
    usa: (
        <FormattedMessage
            id='nations_select.captions.usa'
            defaultMessage='США'
        />
    ),
    china: (
        <FormattedMessage
            id='nations_select.captions.china'
            defaultMessage='Китай'
        />
    ),
    france: (
        <FormattedMessage
            id='nations_select.captions.france'
            defaultMessage='Франция'
        />
    ),
    uk: (
        <FormattedMessage
            id='nations_select.captions.uk'
            defaultMessage='Великобритания'
        />
    ),
    japan: (
        <FormattedMessage
            id='nations_select.captions.japan'
            defaultMessage='Япония'
        />
    ),
    czech: (
        <FormattedMessage
            id='nations_select.captions.czech'
            defaultMessage='Чехословакия'
        />
    ),
    sweden: (
        <FormattedMessage
            id='nations_select.captions.sweden'
            defaultMessage='Швеция'
        />
    ),
    poland: (
        <FormattedMessage
            id='nations_select.captions.poland'
            defaultMessage='Польша'
        />
    ),
    italy: (
        <FormattedMessage
            id='nations_select.captions.italy'
            defaultMessage='Италия'
        />
    ),
}

export const NATIONS_ALL_CAPTION = (
    <FormattedMessage
        id='nations_select.captions.all'
        defaultMessage='Все нации'
    />
)

export const NATIONS_FILTER_TOOOLTIP = {
    id: 'nation_filter_tooltip.id',
    title: (
        <FormattedMessage
            id='nation_filter_tooltip.title'
            defaultMessage='Нация'
        />
    ),
    message: (
        <FormattedMessage
            id='nation_filter_tooltip.body'
            defaultMessage='Фильтровать технику по нации.'
        />
    ),
}

export const VEHICLE_TYPES_TOOLTIPS = {
    heavyTank: {
        id: 'vehicle_types_select.tooltips.heavy_tank.id',
        title: (
            <FormattedMessage
                id='vehicle_types_select.tooltips.heavy_tank.title'
                defaultMessage='Тяжёлые танки'
            />
        ),
    },
    mediumTank: {
        id: 'vehicle_types_select.tooltips.medium_tank.id',
        title: (
            <FormattedMessage
                id='vehicle_types_select.tooltips.medium_tank.title'
                defaultMessage='Средние танки'
            />
        ),
    },
    lightTank: {
        id: 'vehicle_types_select.tooltips.light_tank.id',
        title: (
            <FormattedMessage
                id='vehicle_types_select.tooltips.light_tank.title'
                defaultMessage='Лёгкие танки'
            />
        ),
    },
    SPG: {
        id: 'vehicle_types_select.tooltips.spg.id',
        title: (
            <FormattedMessage
                id='vehicle_types_select.tooltips.spg.title'
                defaultMessage='САУ'
            />
        ),
    },
    'AT-SPG': {
        id: 'vehicle_types_select.tooltips.at_spg.id',
        title: (
            <FormattedMessage
                id='vehicle_types_select.tooltips.at_spg.title'
                defaultMessage='ПТ-САУ'
            />
        ),
    },
}

export const VEHICLE_TYPES_TOOLTIP_BODY = {
    ON: (
        <FormattedMessage
            id='vehicle_types_select.tooltips.on.body'
            defaultMessage='Включить отображение техники данного типа.'
        />
    ),
    OFF: (
        <FormattedMessage
            id='vehicle_types_select.tooltips.off.body'
            defaultMessage='Отключить отображение техники данного типа.'
        />
    ),
}

export const FAVORITE_VEHICLE_TOOLTIP = {
    id: 'vehicle_types_select.tooltips.favorite.id',
    title: (
        <FormattedMessage
            id='vehicle_types_select.tooltips.favorite.title'
            defaultMessage='Основная техника'
        />
    ),
}

export const FAVORITE_VEHICLE_TOOLTIP_BODY = {
    ON: (
        <FormattedMessage
            id='vehicle_types_select.tooltips.favorite.on.body'
            defaultMessage='Включить отображение основной техники.'
        />
    ),
    OFF: (
        <FormattedMessage
            id='vehicle_types_select.tooltips.favorite.off.body'
            defaultMessage='Отключить отображение основной техники.'
        />
    ),
}

export const VEHICLE_FILTER_TOOLTIP = {
    id: 'vehicle_filter_tooltip',
    title: CAPTION,
    message: (
        <FormattedMessage
            id='vehicle_filter_tooltip.message'
            defaultMessage='Нажмите, чтобы изменить выбор техники для сражений.'
        />
    ),
}




// WEBPACK FOOTER //
// ./components/VehicleFilter/constants.jsx